// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"92":"5e1a8f2f","124":"9d77aefe","180":"954706a3","401":"beadb4ac","968":"dc15bbbc"}[chunkId] + ".css";
};